module.exports = __webpack_public_path__ + "static/media/eventmainsmall.5cf295f7.png";